import { render, staticRenderFns } from "./LatenessReportTable.vue?vue&type=template&id=b3bfa218&"
import script from "./LatenessReportTable.vue?vue&type=script&lang=js&"
export * from "./LatenessReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports